import { Model } from "@vuex-orm/core"
import { notify } from "@/services/notification"

export default class Description extends Model {
  static get entity() {
    return "descriptions"
  }

  static UNDEFINED = "A définir"

  static primaryKey = "title"

  static fields() {
    return {
      title: this.attr(""),
      body: this.attr(""),
    }
  }

  static every() {
    const descriptions = Description.query().all()
    if (!descriptions.length) {
      return {}
    }
    return descriptions.reduce((acc, description) => {
      acc[description.title] = description.body
      return acc
    }, {})
  }

  static async getDescriptions() {
    return await this.api()
      .get(`/descriptions`, { dataKey: "data" })
      .catch((error) => {
        notify("error", error)
        return error
      })
  }

  static async createOrUpdateDescription(title, body) {
    return await this.api()
      .post(`/descriptions/${title}`, { body: body }, { dataKey: "data" })
      .catch((error) => {
        notify("error", error)
        return error
      })
  }

  static async deleteDescription(title) {
    return await this.api()
      .delete(`/descriptions/${title}`, {
        delete: title,
      })
      .catch((error) => {
        notify("error", error)
        return error
      })
  }

  static async clearDescription(title) {
    return await this.api()
      .post(`/descriptions/${title}`, { body: "" }, { dataKey: "data" })
      .catch((error) => {
        notify("error", error)
        return error
      })
  }

  static async resetDescriptions() {
    return await this.api()
      .post(`/descriptions/reset`, { dataKey: "data" })
      .catch((error) => {
        notify("error", error)
        return error
      })
  }
}
